import Header from "../components/Header";
import { motion } from "motion/react";
import { routeVariants } from "../routesVariants";
import { Button, Spinner, Text, Title } from "../uikit";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { DOMAIN } from "../consts";
import Card from "../components/Card";
import { getCountryEmoji, translateCity } from "../utils/serverDisplay";
import { getToken } from "../utils/tokenStorage";

export default function SubscriptionOnline() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [connections, setConnections] = useState([]);
  const [fetchedAtMs, setFetchedAtMs] = useState(Date.now());
  const [currentMs, setCurrentMs] = useState(Date.now());
  const { subscription } = location.state || {};

  useEffect(() => {
    if (!subscription) {
      navigate("/account");
    }
  }, [subscription, navigate]);

  const loadOnline = async () => {
    try {
      setIsLoading(true);
      const token = getToken();
      if (token == "" || token == null || !subscription) {
        navigate("/login");
        return;
      }
      const response = await fetch(
        DOMAIN + "/subscriptions/" + subscription.id + "/online",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      ).then((r) => r.json());
      const receivedAtMs = Date.now();
      if (response.success) {
        const sortedConnections = [...(response.connections || [])].sort((left, right) =>
          String(right?.date_created || "").localeCompare(
            String(left?.date_created || "")
          )
        );
        setConnections(sortedConnections);
        setFetchedAtMs(receivedAtMs);
      } else {
        navigate("/account");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadOnline();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentMs(Date.now());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const getConnectionDurationSeconds = (row) => {
    const createdAtMs = Date.parse(row?.date_created || "");
    const serverNowMs = Date.parse(row?.now || "");
    if (Number.isNaN(createdAtMs) || Number.isNaN(serverNowMs)) {
      return null;
    }
    const secondsAtFetch = Math.floor((serverNowMs - createdAtMs) / 1000);
    const secondsAfterFetch = Math.floor((currentMs - fetchedAtMs) / 1000);
    return Math.max(0, secondsAtFetch + Math.max(0, secondsAfterFetch));
  };

  const formatDuration = (totalSeconds) => {
    const safeSeconds = Math.max(0, totalSeconds);
    const days = Math.floor(safeSeconds / 86400);
    const hours = Math.floor((safeSeconds % 86400) / 3600);
    const minutes = Math.floor((safeSeconds % 3600) / 60);
    const seconds = safeSeconds % 60;

    const parts = [];
    if (days > 0) {
      parts.push(`${days}d`);
    }
    if (hours > 0 || days > 0) {
      parts.push(`${hours}h`);
    }
    if (minutes > 0 || hours > 0 || days > 0) {
      parts.push(`${minutes}m`);
    }
    parts.push(`${seconds}s`);
    return parts.join(" ");
  };

  return (
    <motion.div
      className="container background-regular border-padding column-spacing column"
      variants={routeVariants}
      initial="initial"
      animate="final"
      exit="exit"
    >
      <Header isBack={true} backCallback={() => navigate("/account")}>
        <Title level="1" weight="3">
          {t("Online")} {subscription?.login ? subscription.login : ""}
        </Title>
      </Header>

      {isLoading ? (
        <div className="center full-height">
          <Spinner />
        </div>
      ) : (
        <>
          {connections.length ? (
            connections.map((row) => (
              <Card>
                <div className="column card">
                  <div
                    className="row space-between vertical-center"
                    key={`${row.local_ip}-${row.server_name}-${row.date_created}`}
                  >
                    <div className="column">
                      <Text>
                        {(() => {
                          const location = [
                            getCountryEmoji(row.exit_server_country_code),
                            translateCity(
                              row.exit_server_city,
                              row.exit_server_city_ru,
                              i18n.resolvedLanguage,
                            ),
                          ]
                            .filter(Boolean)
                            .join(" ");
                          return [location, row.exit_server_name]
                            .filter(Boolean)
                            .join(" - ");
                        })()}
                      </Text>
                      <Text style={{ opacity: 0.7 }}>
                        {row.exit_address || "-"}
                      </Text>
                      <Text style={{ opacity: 0.7 }}>
                        {row.local_ip || "-"}
                      </Text>
                      <Text style={{ opacity: 1 }}>
                        {(() => {
                          const durationSeconds = getConnectionDurationSeconds(row);
                          if (durationSeconds == null) {
                            return "";
                          }
                          return `${formatDuration(durationSeconds)}`;
                        })()}
                      </Text>
                    </div>
                    <Button
                      mode="plain"
                      size="s"
                      onClick={() =>
                        navigate("/account/outlet", {
                          state: {
                            subscription,
                            connection: row,
                            mode: "online",
                          },
                        })
                      }
                    >
                      {t("Change location")}
                    </Button>
                  </div>
                </div>
              </Card>
            ))
          ) : (
            <Card>
              <div className="column card">
                <div className="row">
                  <Text>{t("No online connections")}</Text>
                </div>
              </div>
            </Card>
          )}
        </>
      )}
    </motion.div>
  );
}
